import loadables from './loadables';
import routes from '../../routes';

const routeList = (route) => {
  return [
    route({
      key: routes.root.path,
      path: routes.root.path,
      component: loadables.root,
    }),

    route({
      key: routes.home.path,
      path: routes.home.path,
      component: loadables.home,
    }),

    route({
      guest: true,
      key: routes.login.path,
      path: routes.login.path,
      component: loadables.login,
    }),

    route({
      guest: true,
      key: routes.passwordRecovery.path,
      path: routes.passwordRecovery.path,
      component: loadables.passwordRecovery,
    }),

    route({
      guest: true,
      key: routes.passwordChange.path,
      path: routes.passwordChange.path,
      component: loadables.passwordChange,
    }),

    route({
      guest: true,
      key: routes.signup.path,
      path: routes.signup.path,
      component: loadables.signup,
    }),

    route({
      auth: true,
      key: routes.settings.path,
      path: routes.settings.path,
      component: loadables.settings,
    }),

    route({
      auth: true,
      key: routes.signupComplete.path,
      path: routes.signupComplete.path,
      component: loadables.signupComplete,
    }),

    route({
      auth: true,
      key: routes.confirmAccount.path,
      path: routes.confirmAccount.path,
      component: loadables.confirmAccount,
    }),

    route({
      auth: true,
      key: routes.dashboardEmpty.path,
      path: routes.dashboardEmpty.path,
      component: loadables.dashboardEmpty,
    }),

    route({
      auth: true,
      key: routes.dashboard.path,
      path: routes.dashboard.path,
      component: loadables.dashboard,
    }),

    route({
      auth: true,
      key: routes.monthlyView.path,
      path: routes.monthlyView.path,
      component: loadables.monthlyView,
    }),

    route({
      auth: true,
      key: routes.monthlyViewBoard.path,
      path: routes.monthlyViewBoard.path,
      component: loadables.monthlyView,
    }),

    route({
      auth: true,
      key: routes.boards.path,
      path: routes.boards.path,
      component: loadables.boards,
    }),

    route({
      auth: true,
      key: routes.calendar.path,
      path: routes.calendar.path,
      component: loadables.calendar,
    }),

    route({
      auth: true,
      key: routes.templates.path,
      path: routes.templates.path,
      component: loadables.templates,
    }),

    route({
      auth: true,
      key: routes.scribbler.path,
      path: routes.scribbler.path,
      component: loadables.scribbler,
    }),

    route({
      key: 'notFound',
      path: '*',
      component: loadables.notFound,
    }),
  ];
};

export default routeList;
